<template>
  <div id="app">
    <!-- <img alt="Vue logo" src="./assets/logo.png"> -->
    <!-- <HomePage /> -->
    <router-view></router-view>
    <BackTop />

  </div>
</template>

<script>
// import HomePage from './views/HomePage.vue'

export default {
  name: 'App',
  components: {
    // HomePage
  }
}
</script>

<style>
#app {
width: 100%;
height: 100%;
  /* margin-top: 60px; */
}
</style>
